export const EDGE_INFO_LIST = 'EDGE_INFO_LIST';
export const EDGE_INFO_LIST_SUCCESS = 'EDGE_INFO_LIST_SUCCESS';
export const EDGE_INFO_LIST_ERROR = 'EDGE_INFO_LIST_ERROR';
export const EDGE_INFO_LIST_DETAILS = 'EDGE_INFO_LIST_DETAILS';
